import { SportDefinition, SportProfileField } from '../sport.types';
import { SOFTBALL_POSITIONS } from './softball.enums';
import { SoftballScoringAdapter } from './softball-scoring.adapter';
import { SoftballLiveScorerComponent } from './components/softball-live-scorer.component';
import { SoftballScoringSetupComponent } from './components/softball-scoring-setup.component';
import { SoftballSpectatorComponent } from './components/softball-spectator.component';

const profileFields: SportProfileField[] = [
  {
    key: 'primaryPosition',
    label: 'Primary position',
    section: 'profile',
    type: 'select',
    filterable: true,
    options: SOFTBALL_POSITIONS.map(p => ({ value: p.value, label: p.label }))
  },
  { key: 'jerseyNumber', label: 'Jersey #', section: 'profile', type: 'number', min: 0, max: 99 },
  {
    key: 'battingSide',
    label: 'Bats',
    section: 'profile',
    type: 'select',
    options: [
      { value: 1, label: 'Right' },
      { value: 2, label: 'Left' },
      { value: 3, label: 'Switch' }
    ]
  },
  {
    key: 'throwingHand',
    label: 'Throws',
    section: 'profile',
    type: 'select',
    options: [
      { value: 1, label: 'Right' },
      { value: 2, label: 'Left' }
    ]
  },
  { key: 'pitching.maxPitches', label: 'Max pitches', section: 'profile', type: 'number', min: 0, max: 200 }
];

export function createSoftballSportDefinition(input: { scoring: SoftballScoringAdapter }): SportDefinition {
  return {
    key: 'softball',
    label: 'Softball',
    icon: 'sports_softball',
    colorToken: '--brijjsports-purple',
    athletesNoun: 'Players',
    terminology: {
      eventNoun: 'Tournament',
      eventNounPlural: 'Tournaments',
      sessionNoun: 'Game',
      opponentNoun: 'Opponent',
      scoreUnitNoun: 'Run',
      resultPlacementHelp: '1st, Runner-up, Pool A'
    },
    rulesSummary: 'Seven-inning games scored by runs; fastpitch and slowpitch flows, windmill pitch counts, and DP/Flex lineups.',
    scoring: input.scoring,
    profileFields,
    setupComponent: SoftballScoringSetupComponent,
    liveComponent: SoftballLiveScorerComponent,
    spectatorComponent: SoftballSpectatorComponent,
    nav: {
      owner: [
        { route: '/owner/athletes', label: 'Players', icon: 'users' },
        { route: '/owner/programs', label: 'Programs', icon: 'layers' },
        { route: '/owner/teams', label: 'Teams', icon: 'users' }
      ],
      coach: [
        { route: '/coach/roster', label: 'Players', icon: 'users' },
        { route: '/coach/scoring', label: 'Box scores', icon: 'bar-chart' }
      ],
      athlete: [{ route: '/athlete/scores', label: 'Box scores', icon: 'bar-chart' }]
    }
  };
}
